import { useContactManagementTranslation } from '../../../../ui/hooks';
import React from 'react';
import { ColumnOrderStep } from '../components/AccountsExportTemplate/ColumnOrderStep';
import { SelectFieldsStep } from '../components/AccountsExportTemplate/SelectFieldsStep';
export const useAccountExportWizardSteps = () => {
    const { t } = useContactManagementTranslation();
    const selectFieldsStep = (stepProps = {}) => ({
        label: t('export.selectFields'),
        render: (props) => React.createElement(SelectFieldsStep, Object.assign({}, props, stepProps)),
    });
    const columnOrderStep = (stepProps = {}) => ({
        label: t('export.columnOrder'),
        render: (props) => React.createElement(ColumnOrderStep, Object.assign({}, props, stepProps)),
    });
    return { selectFieldsStep, columnOrderStep };
};
